import { configureStore } from '@reduxjs/toolkit';
import langReducer from './slices/lang';
import machinesReducer from './slices/machines';
import templatesReducer from './slices/templates';
import issuesReducer from './slices/issues';
import causesReducer from './slices/causes';
import solutionGridsReducer from './slices/solutionGrids';
import profileReducer from './slices/profile';
import notificationReducer from './slices/notifications';
import routineReducer from './slices/routines';
import companyReducer from './slices/companies';
import eventReducer from './slices/event';
import { useDispatch } from 'react-redux';

export const store = configureStore({
  reducer: {
    lang: langReducer,
    machines: machinesReducer,
    templates: templatesReducer,
    issues: issuesReducer,
    causes: causesReducer,
    solutionGrids: solutionGridsReducer,
    profile: profileReducer,
    notification: notificationReducer,
    routines: routineReducer,
    companies: companyReducer,
    event: eventReducer,
  },
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const useAppDispatch: () => AppDispatch = useDispatch;
